import { createSingletonState } from "singleton-state";
function noop() {
    return "";
}
function now() {
    try {
        return Math.round(performance.now());
    }
    catch (_a) {
        return 0;
    }
}
var dummy = {
    register: noop,
    unregister: noop,
    dispatch: noop,
};
var instance = createSingletonState("@1js/search-dispatcher", dummy);
var contract = [
    "register",
    "unregister",
    "dispatch",
];
export function setDispatcher(dispatcher) {
    if (!dispatcher) {
        throw new Error("Dispatcher argument must be a dispatcher instance.");
    }
    if (!contract.every(function (method) { return typeof dispatcher[method] === "function"; })) {
        throw new Error("Dispatcher argument must implement dispatcher interface.");
    }
    instance.set({
        register: dispatcher.register.bind(dispatcher),
        unregister: dispatcher.unregister.bind(dispatcher),
        dispatch: function (event) {
            // Only set the dispatch time on the log event if it doesn't already have one.
            // Depending on how we implement buffering of log events, we might end
            // up dispatching the same log event twice. In that case, we are more
            // interested in the original dispatch time.
            //
            // Note that the LogEvent type is typed with readonly members to discourage
            // mutation of log events, but here we are willing to mutate it in-place.
            var dispatchTime = event.dispatchTime;
            event.dispatchTime =
                typeof dispatchTime === "number" ? dispatchTime : now();
            dispatcher.dispatch(event);
        },
    });
}
export function getDispatcher() {
    return instance.get();
}
/**
 * Check if the dispatcher has been set.
 * @returns True if the dispatcher has been set, false otherwise.
 */
export function hasDispatcherBeenSet() {
    return instance.get() !== dummy;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGlzcGF0Y2hlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9kaXNwYXRjaGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLE9BQU8sRUFBRSxvQkFBb0IsRUFBRSxNQUFNLGlCQUFpQixDQUFDO0FBRXZELFNBQVMsSUFBSTtJQUNYLE9BQU8sRUFBRSxDQUFDO0FBQ1osQ0FBQztBQUVELFNBQVMsR0FBRztJQUNWLElBQUk7UUFDRixPQUFPLElBQUksQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLEdBQUcsRUFBRSxDQUFDLENBQUM7S0FDdEM7SUFBQyxXQUFNO1FBQ04sT0FBTyxDQUFDLENBQUM7S0FDVjtBQUNILENBQUM7QUFFRCxJQUFNLEtBQUssR0FBMEI7SUFDbkMsUUFBUSxFQUFFLElBQUk7SUFDZCxVQUFVLEVBQUUsSUFBSTtJQUNoQixRQUFRLEVBQUUsSUFBSTtDQUNmLENBQUM7QUFFRixJQUFNLFFBQVEsR0FBRyxvQkFBb0IsQ0FDbkMsd0JBQXdCLEVBQ3hCLEtBQUssQ0FDTixDQUFDO0FBRUYsSUFBTSxRQUFRLEdBQStDO0lBQzNELFVBQVU7SUFDVixZQUFZO0lBQ1osVUFBVTtDQUNYLENBQUM7QUFFRixNQUFNLFVBQVUsYUFBYSxDQUFDLFVBQWlDO0lBQzdELElBQUksQ0FBQyxVQUFVLEVBQUU7UUFDZixNQUFNLElBQUksS0FBSyxDQUFDLG9EQUFvRCxDQUFDLENBQUM7S0FDdkU7SUFFRCxJQUFJLENBQUMsUUFBUSxDQUFDLEtBQUssQ0FBQyxVQUFDLE1BQU0sSUFBSyxPQUFBLE9BQU8sVUFBVSxDQUFDLE1BQU0sQ0FBQyxLQUFLLFVBQVUsRUFBeEMsQ0FBd0MsQ0FBQyxFQUFFO1FBQ3pFLE1BQU0sSUFBSSxLQUFLLENBQUMsMERBQTBELENBQUMsQ0FBQztLQUM3RTtJQUVELFFBQVEsQ0FBQyxHQUFHLENBQUM7UUFDWCxRQUFRLEVBQUUsVUFBVSxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsVUFBVSxDQUFDO1FBQzlDLFVBQVUsRUFBRSxVQUFVLENBQUMsVUFBVSxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUM7UUFDbEQsUUFBUSxFQUFFLFVBQUMsS0FBSztZQUNkLDhFQUE4RTtZQUM5RSxzRUFBc0U7WUFDdEUscUVBQXFFO1lBQ3JFLDRDQUE0QztZQUM1QyxFQUFFO1lBQ0YsMkVBQTJFO1lBQzNFLHlFQUF5RTtZQUN6RSxJQUFNLFlBQVksR0FBRyxLQUFLLENBQUMsWUFBWSxDQUFDO1lBQ3ZDLEtBQWtDLENBQUMsWUFBWTtnQkFDOUMsT0FBTyxZQUFZLEtBQUssUUFBUSxDQUFDLENBQUMsQ0FBQyxZQUFZLENBQUMsQ0FBQyxDQUFDLEdBQUcsRUFBRSxDQUFDO1lBQzFELFVBQVUsQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLENBQUM7UUFDN0IsQ0FBQztLQUNGLENBQUMsQ0FBQztBQUNMLENBQUM7QUFFRCxNQUFNLFVBQVUsYUFBYTtJQUMzQixPQUFPLFFBQVEsQ0FBQyxHQUFHLEVBQUUsQ0FBQztBQUN4QixDQUFDO0FBRUQ7OztHQUdHO0FBQ0gsTUFBTSxVQUFVLG9CQUFvQjtJQUNsQyxPQUFPLFFBQVEsQ0FBQyxHQUFHLEVBQUUsS0FBSyxLQUFLLENBQUM7QUFDbEMsQ0FBQyJ9